import React from "react";

interface BrandGlyphProps {
  size?: number;
  animated?: boolean;
  className?: string;
}

// Renders the Meylo icon.svg using img tag
const BrandGlyph: React.FC<BrandGlyphProps> = ({ size = 32, animated = true, className }) => {
  return (
    <img
      src="/icon.svg"
      alt="Meylo"
      width={size}
      height={size}
      className={`${animated ? "animated-brand-icon" : ""} ${className || ""}`}
      style={{ display: "block" }}
    />
  );
};

export default BrandGlyph;




